export default __webpack_public_path__ + "static/barlow-v4-latin-600-83d7bbe3f99c8fac1d4cc9664871d33b.svg";